<template>
  <v-card>
    <v-card-title>{{title}}</v-card-title>
    <v-card-text>
      This is another dummy with value {{localValue}}
      This one emits all changes as "input" event.
      Extra button, emits, "click" event to passed handlers.
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="primary"
        @click.prevent="handleAddClick"
        href="#"
      >Add +</v-btn>
      <v-btn
        color="danger"
        @click.prevent="handleTestClick"
        href="#"
      >Test</v-btn>
    </v-card-actions>

  </v-card>
</template>
<script>
export default {
  name: 'AnotherDummy',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      localValue: this.value
    }
  },
  watch: {
    localValue (value) {
      this.$emit('input', value)
    }
  },
  methods: {
    handleAddClick () {
      this.localValue++
    },
    handleTestClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>
